export default "__VITE_ASSET__Ce7jll8G__"